<!------------------------------------------------------------------------------
 File: Plates
 Created by keni.
 with: IntelliJ IDEA
 Date: 28/08/2018
 Time: 10:37
------------------------------------------------------------------------------->
<template>
    <div data-ref="component.plate">

        <div v-if="!newAsset.plate" data-ref="!newAsset.plate" class="container mb-3">
            <div class="d-flex justify-content-end align-content-center">
                <floating-button
                        @clicked="createAsset"
                        button_color="btn-primary"
                        :relative="true"
                ></floating-button>
            </div>
        </div>

        <!--new asset display-->
        <transition name="fade">
            <div v-if="newAsset.plate"
                 class="p-3 mb-2 card ml-auto  mr-auto"
            >
                <div class="card-body bg-info">
                    <div class="row">
                        <div class="col-md-6 col-12 mb-4 mb-md-0 plate">
                            <input
                                    autocomplete="off"
                                    :id="plateModelId"
                                    @keyup="onPlateInput(0,'plate_')"
                                    @keydown.alt="altKeyPressed = true"
                                    ref="plate_0"
                                    type="text"
                                    class=""
                                    v-model="plateModel"
                                    title="create new asset"
                                    maxlength="8"
                            >
                        </div>
                        <div class="offset-2 col-md-2 col-4 align-self-center text-right">
                            <BaseButtonRound
                                    v-on:click.native="storeAsset('plate')"
                                    class="ml-3 my-0"
                                    btn_type="btn-primary"
                                    type="div"
                                    :small="false"
                                    :tooltip="false"
                            >
                                <template slot="content">
                                    <i class="material-icons" aria-hidden="true">save</i>
                                </template>
                            </BaseButtonRound>
                        </div>
                        <div class="col-md-2 col-4 align-self-center text-right">
                            <BaseButtonRound
                                v-on:click.native="cancelAsset"
                                class="my-0"
                                btn_type="btn-danger"
                                type="div"
                                :small="false"
                                :tooltip="false"
                        >
                            <template slot="content">
                                <i class="material-icons" aria-hidden="true">cancel</i>
                            </template>
                        </BaseButtonRound>
                        </div>
                    </div>
                </div>
                <div v-if="altKeyPressed"
                     v-on:click="altKeyPressed = false"
                     class="small p-1 m-1 bg-warning z-depth-1 align-center cursor-pointer">
                    Do not press the Alt key. Click here to continue editing the plate
                </div>
            </div>
        </transition>
        <!--the plate contents-->
        <section v-if="!loading" :key="loading">
            <div v-for="plate in plates" :key="plate.id" class="container">
                <!--{{debug(plate)}}-->
                <div class="row mb-1">
                    <div class="col-md-6 col-12 mb-2 mb-md-0 plate">
                        {{plate.value}}
                    </div>
                    <div class="col-md-4 col-8 align-self-center text-left text-md-right">
                        {{setDate(plate.updated_at)}}
                    </div>
                    <div class="col-md-2 col-4 align-self-center text-right">
<!--                        delete asset button-->
                        <BaseButtonRound
                                v-on:click.native="confirmDelete(plate)"
                                class="my-0"
                                btn_type="btn-danger"
                                type="div"
                                :small="false"
                                :tooltip="false"
                        >
                            <template slot="content">
                                <i class="material-icons" aria-hidden="true">delete</i>
                            </template>
                        </BaseButtonRound>
                    </div>
                </div>
                <hr class="d-block d-md-none mb-2">
<!--                <div class="d-flex flex-sm-row flex-column justify-content-center align-items-center mb-2"-->
<!--                     :class="{-->
<!--                        'mt-3':newAsset.plate-->
<!--                        }"-->
<!--                >-->
<!--                    <div class="d-flex justify-content-between align-content-center">-->
<!--                        <div class="plate mr-4">{{plate.value}}</div>-->
<!--                        <div>-->
<!--                            <BaseButtonRound-->
<!--                                    v-on:click.native="confirmDelete(plate)"-->
<!--                                    class="my-0"-->
<!--                                    btn_type="btn-danger"-->
<!--                                    type="div"-->
<!--                                    :small="false"-->
<!--                                    :tooltip="false"-->
<!--                            >-->
<!--                                <template slot="content">-->
<!--                                    <i class="material-icons" aria-hidden="true">delete</i>-->
<!--                                </template>-->
<!--                            </BaseButtonRound>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        {{setDate(plate.updated_at)}}-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </section>
        <div v-else :key="loading" class="progress md-progress primary-color-dark">
            <div class="indeterminate"></div>
        </div>

        <!--delete plate notification-->
        <simple-modal v-if="showModal"
                      @onfirm="deleteAsset"
                      @close="cancelDelete"
                      @cancel="cancelDelete"
                      :footer="{
            cls:'pr-0'
        }"
        >
            <h3 slot="header" class="h3-responsive">
                Delete from records?
            </h3>

            <div slot="body" class="mt-1">
                <div class="mb-3">
                    <div class="plate">
                        {{assetToDelete}}
                    </div>
                </div>
                <p class="text-muted fs-3">This plate will disappear from this device and anywhere else you use to read
                    this record</p>
            </div>
            <div slot="footer" class="w-100">
                <div class="d-flex justify-content-between align-content-center">
                    <span class="cursor-pointer p-3" v-on:click="cancelDelete">Cancel</span>
                    <span class="cursor-pointer p-3" v-on:click="deleteAsset">Confirm</span>
                </div>
            </div>
        </simple-modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import PlateFormatMixin from "./PlateFormatMixin";
    import {DATE_FORMAT, getDate} from "../helpers/format.date";
    // import {DATE_FORMAT,getDate} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.date';

    Vue.component('simple-modal', require('./notifications/SimpleModal'));
    Vue.component('floating-button', require('./buttons/FloatingButton'));

    export default {
        name: "plates",
        components: {},
        mixins: [PlateFormatMixin],
        props: {
            user_id: String,
            read: String,
            store: String,
            delete: String,
            user_assets_group_id:{
                type:Number,
                default: 0
            }
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            this.readAssets();
        },
        data() {
            return {
                altKeyPressed: false,
                loading: false,
                showModal: false,
                selectedDeleteId: null,
                delete_confirmed: false,
                plateModel: '',
                plates: {},
                newAsset: {
                    plate: false
                },
                assetToDelete:null,
                plateModelId: _.uniqueId('plate_')
            }
        },
        methods: {
            setDate(date) {
                return getDate(date, DATE_FORMAT.date_time.short);
            },
            onPlateInput(position, reference) {
                this.watchInput(position, reference, this.plateModel);
            },
            debug(s) {
                let args = Array.prototype.slice.call(arguments);

                // 2. Prepend log prefix log string
                // args.unshift(LOG_PREFIX + " ");

                // 3. Pass along arguments to console.log
                console.log.apply(console, args);
            },
            cancelDelete() {
                this.showModal = false;
                this.selectedDeleteId = null;
                return this;
            },
            confirmDelete(asset) {

                let self = this;

                self.showModal = true;
                self.selectedDeleteId = asset.id;
                self.assetToDelete = asset.value;
                // console.log('confirmDelete', 'self.selectedDeleteId', self.selectedDeleteId);
            },
            deleteAsset() {
                let self = this;

                if (self.selectedDeleteId === null) {
                    return false;
                }

                let data = self.createUserRequestData({
                    id: self.selectedDeleteId,
                });

                // console.log('deleteAsset', 'self.selectedDeleteId',self.selectedDeleteId);

                axios.post(self.delete, data)
                    .then(function (response) {
                        if (response.data.success) {
                            self.readAssets();
                        }
                    })
                    .catch(function () {
                        self.cancelDelete();
                    });
            },
            cancelAsset() {
                this.plateModel = '';
                this.newAsset.plate = false;

                return this;
            },
            createAsset() {
                this.newAsset.plate = true;
                // console.log('createAsset', 'creating', this.newAsset.plate);
            },
            storeAsset() {
                let self = this;
                if (self.plateModel === '') {
                    return;
                }
                let data = self.createUserRequestData({
                    type: 'plate',
                    value: self.plateModel,
                });

                axios.post(self.store, data)
                    .then(function (response) {
                        if (response.data.success) {
                            // console.log('', 'response.data.success', response.data.success);
                            self.readAssets();
                        }
                    })
                    .catch(function () {

                    });
            },
            createUserRequestData(data){
                let self = this;
                if(self.user_assets_group_id > 0){
                    data['user_assets_group_id'] = self.user_assets_group_id
                }else{
                    data['user_id'] = self.user_id;
                }
                // data['user_id'] = 30034;
                return data;
            },
            readAssets() {
                let self = this,
                    data = self.createUserRequestData({
                        type: 'plate',
                    });

                self.loading = true;
                self.cancelDelete().cancelAsset();
                axios.post(self.read, data)
                    .then(function (response) {
                        if (response.data.success) {
                            self.plates = response.data.plate;
                        }
                        self.loading = false;
                    })
                    .catch(function () {
                        self.loading = false;
                    })
                .then(function(){
                    self.assetToDelete = null;
                });
            }
        },
        watch: {},
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/Plates.vue?2950c7ec